<script lang="ts">
  import MiniStoriesContentCardDisplay from "@shared/svelte/Components/MiniStories/MiniStoriesContentCardDisplay.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import {
    MiniStoriesContentCardAdEntity,
    MiniStoriesContentCardEntity,
  } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";

  import type { MiniStory } from "@shared/types/MiniStory";

  const { trackClick, trackMrcEvents } = EventTracking;

  export let miniStory: MiniStory;
  export let index: number;

  const trackingParams = [];

  const miniStoriesContentCardParams: MiniStoriesContentCardEntity =
    new MiniStoriesContentCardEntity(miniStory);

  trackingParams.push(miniStoriesContentCardParams);

  if (miniStory?.paid_tracking_values) {
    const miniStoryAdParams: MiniStoriesContentCardAdEntity = new MiniStoriesContentCardAdEntity({
      ...miniStory.paid_tracking_values,
      image_upload_url: miniStory.image_upload_url,
    });

    trackingParams.push(miniStoryAdParams);
  }

  const { href, target } = reformatUrlAndGetTargetValue(miniStory.forward_url);
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <a
    {href}
    {target}
    class="fizz-card fizz-card-interactive fizz-radius-medium fizz-flex-item fizz-text-brand"
    use:trackMrcEvents={[trackingContext.entities]}
    on:click={e => trackClick(null, trackingContext.entities)}
  >
    <MiniStoriesContentCardDisplay
      description={miniStory.description}
      imageAltText={miniStory.image_alt_text}
      imageUrl={miniStory.image_upload_url}
      {index}
      title={miniStory.title}
      useThumbnail={miniStory.use_thumbnail}
      videoUploadUrl={miniStory.video_upload_url}
      trackingParams={trackingContext.entities}
      displaySponsoredLabel={miniStory.display_sponsored_label}
    />
  </a>
</TrackingContext>
